export const validateManualForm = (form: HTMLFormElement): boolean => {
  const controls = Array.from(
    form.elements,
    (control: Element): false | HTMLInputElement | HTMLSelectElement =>
      (control instanceof HTMLInputElement || control instanceof HTMLSelectElement) &&
      control,
  ).filter(
    (
      value: false | HTMLInputElement | HTMLSelectElement,
    ): value is HTMLInputElement | HTMLSelectElement => !!value,
  );

  const errors = controls
    .map((control) => {
      if (control.getAttribute('aria-disabled') === 'true') {
        return undefined;
      }

      // Custom validation for dollar amount
      if (control.name === 'dollarAmount' && control.value === '$') {
        control.setCustomValidity('Please enter Approximate dollar amount');
      } else {
        control.setCustomValidity(''); // Reset custom validity
      }

      // this part actually triggers the error messages inline
      control.checkValidity();

      const { validity } = control;
      const { valid } = validity;

      // this part resets to a valid state if field is given input
      control.setAttribute('aria-invalid', `${!valid}`);

      if (!valid) {
        return control;
      }

      return undefined;
    })
    .filter(
      (
        value: undefined | HTMLInputElement | HTMLSelectElement,
      ): value is HTMLInputElement | HTMLSelectElement => !!value,
    );

  console.log(errors);
  return errors.length === 0;
};
